// import React, { useState, useEffect } from "react";
// import { Box, Paper, Typography, Stack, Chip } from "@mui/material";
// import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
// //import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// //import IPDCFormHeader from "../../../../components/Forms/IPDCFormHeader";

// function SystemHealth() {
//   const [systemStatus, setSystemStatus] = useState("healthy");
//   const [statusColor, setStatusColor] = useState("green");

//   useEffect(() => {
//     const checkNetwork = async () => {
//       try {
//         //const status=await GetDataFromApiWithParams("");
//         //console.log(status);

//         //if(status){
//         setSystemStatus("healthy");
//         setStatusColor("green");
//         /*}else{
// //          setSystemStatus("Network interupted");
//   //        setStatusColor("error");
//     //    }*/
//       } catch (error) {
//         setSystemStatus("Network interupted");
//         setStatusColor("red");
//       }
//     };

//     const intervalId = setInterval(checkNetwork, 5000); // Check network every 50 seconds

//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         width: { xs: "100%", sm: "50%" },
//         verticalAlign: "middle",
//         maxWidth: "400px",
//         margin: "0 auto", // centers the paper if less than full width
//       }}
//     >
//       <Box p={{ xs: 2, md: 10 }} m={1}>
//         <Typography
//           variant="h6"
//           align="center"
//           sx={{
//             fontSize: { xs: "1rem", sm: "1.5rem" },
//             color: statusColor,
//           }}
//         >
//           System Status:
//         </Typography>
//         <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="center" spacing={1}>
//           <HealthAndSafetyIcon fontSize="large" sx={{ fill: statusColor }} />
//           <Chip
//             label={systemStatus}
//             variant="outlined"
//             sx={{
//               width: { xs: "100%", sm: "auto" },
//             }}
//           />
//         </Stack>
//       </Box>
//     </Paper>
//   );
// }

// export default SystemHealth;
//********************************************************************************** */
import React, { useState, useEffect, useCallback } from "react";
import { Box, Paper, Typography, Stack, Chip, CircularProgress } from "@mui/material";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import ApiIcon from "@mui/icons-material/Api";
import StorageIcon from "@mui/icons-material/Storage";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";

function SystemHealth() {
  const [checks, setChecks] = useState({
    backend: { status: "checking", message: "Checking backend connection...", color: "info" },
    database: { status: "checking", message: "Checking database connection...", color: "info" },
    api: { status: "checking", message: "Checking API endpoints...", color: "info" },

  });
  
  const [overallStatus, setOverallStatus] = useState("checking");
  const [isChecking, setIsChecking] = useState(true);

  // Function to check backend health
  const checkBackend = useCallback(async () => {
    try {
      const response = await GetDataFromApiWithParams("/health/backend");
      
      if (response && response.status === "healthy") {
        return { 
          status: "healthy", 
          message: "Backend server is running", 
          color: "success" 
        };
      } else {
        return { 
          status: "error", 
          message: "Backend server is not listening", 
          color: "error" 
        };
      }
    } catch (error) {
      return { 
        status: "error", 
        message: "Backend server is not accessible", 
        color: "error" 
      };
    }
  }, []);

  // Function to check database connection
  const checkDatabase = useCallback(async () => {
    try {
      const response = await GetDataFromApiWithParams("/health/database");
      
      if (response && response.status === "connected") {
        return { 
          status: "healthy", 
          message: "Database connection established", 
          color: "success" 
        };
      } else {
        return { 
          status: "error", 
          message: "Cannot connect to database", 
          color: "error" 
        };
      }
    } catch (error) {
      return { 
        status: "error", 
        message: "Database connection error", 
        color: "error" 
      };
    }
  }, []);

  // Function to check API endpoints
  const checkAPI = useCallback(async () => {
    try {
      const response = await GetDataFromApiWithParams("/health/api");
      
      if (response && response.status === "available") {
        return { 
          status: "healthy", 
          message: "API endpoints are responding", 
          color: "success" 
        };
      } else {
        return { 
          status: "warning", 
          message: "API endpoints are slow or unresponsive", 
          color: "warning" 
        };
      }
    } catch (error) {
      return { 
        status: "error", 
        message: "API endpoints are not accessible", 
        color: "error" 
      };
    }
  }, []);

  // Function to check WebSocket connection
 

  // Function to run all checks
  const runAllChecks = useCallback(async () => {
    setIsChecking(true);
    
    try {
      const [backendResult, databaseResult, apiResult, websocketResult] = await Promise.all([
        checkBackend(),
        checkDatabase(),
        checkAPI(),
        
      ]);
      
      const newChecks = {
        backend: backendResult,
        database: databaseResult,
        api: apiResult,
      };
      
      setChecks(newChecks);
      
      // Determine overall status
      const hasError = Object.values(newChecks).some(check => check.status === "error");
      const hasWarning = Object.values(newChecks).some(check => check.status === "warning");
      
      if (hasError) {
        setOverallStatus("error");
      } else if (hasWarning) {
        setOverallStatus("warning");
      } else {
        setOverallStatus("healthy");
      }
    } catch (error) {
      console.error("Error running health checks:", error);
      setOverallStatus("error");
    } finally {
      setIsChecking(false);
    }
  }, [checkBackend, checkDatabase, checkAPI ]);

  useEffect(() => {
    runAllChecks();
    
    const intervalId = setInterval(runAllChecks, 30000); // Check every 30 seconds
    
    return () => clearInterval(intervalId);
  }, [runAllChecks]);

  const getStatusIcon = (status) => {
    switch(status) {
      case "healthy":
        return <CheckCircleIcon sx={{ color: "green" }} />;
      case "error":
        return <ErrorIcon sx={{ color: "red" }} />;
      case "warning":
        return <WarningIcon sx={{ color: "orange" }} />;
      default:
        return <CircularProgress size={20} />;
    }
  };

  // Get the main HealthAndSafetyIcon color based on overall status
  const getMainIconColor = () => {
    switch(overallStatus) {
      case "healthy":
        return "green";
      case "warning":
        return "orange";
      case "error":
        return "red";
      default:
        return "gray";
    }
  };

  // Get the status text based on overall status
  const getStatusText = () => {
    switch(overallStatus) {
      case "healthy":
        return "System Status: The system is Healthy";
      case "warning":
        return "System Status: There is some problem in the system";
      case "error":
        return "System Status: Critical problem happened in the system";
      default:
        return "System Status: Checking system health...";
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: { xs: "100%", sm: "50%" },
        verticalAlign: "middle",
        maxWidth: "400px",
        margin: "0 auto",
      }}
    >
      <Box p={{ xs: 2, md: 10 }} m={1}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <HealthAndSafetyIcon 
            fontSize="large" 
            sx={{ 
              fill: getMainIconColor(),
              fontSize: { xs: "2rem", sm: "2.5rem" }
            }} 
          />
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontSize: { xs: "0.9rem", sm: "1.2rem" },
              fontWeight: "bold",
              color: getMainIconColor(),
            }}
          >
            {getStatusText()}
          </Typography>
        </Stack>
        
        <Stack direction="column" spacing={2}>
          {Object.entries(checks).map(([key, value]) => (
            <Stack 
              key={key}
              direction="row" 
              alignItems="center" 
              justifyContent="space-between"
              spacing={1}
              sx={{
                p: 1,
                borderRadius: 1,
                bgcolor: value.color === "success" ? "rgba(76, 175, 80, 0.1)" :
                        value.color === "error" ? "rgba(244, 67, 54, 0.1)" :
                        value.color === "warning" ? "rgba(255, 152, 0, 0.1)" :
                        "transparent"
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                {key === "backend" && <ApiIcon fontSize="small" />}
                {key === "database" && <StorageIcon fontSize="small" />}
                {key === "api" && <CloudSyncIcon fontSize="small" />}
                <Typography variant="body2" sx={{ textTransform: "capitalize", fontWeight: "medium" }}>
                  {key}:
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {value.message}
                </Typography>
              </Stack>
              {getStatusIcon(value.status)}
            </Stack>
          ))}
        </Stack>
        
        {isChecking && (
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mt={2}>
            <CircularProgress size={20} />
            <Typography variant="caption">Checking system status...</Typography>
          </Stack>
        )}
      </Box>
    </Paper>
  );
}

export default SystemHealth;